export default "__VITE_ASSET__RaZx8UR8__"